const CreditResourceType = {
  None: 0,
  Trial: 1,
  Promotion: 2,
  BulkSale: 3,
  AppleStore: 4,
  GoogleStore: 5,
  OnlineSale: 6,
  HuaweiStore: 7,
  HuaweiIyzico: 8,
  External: 9,
};

// Human-readable labels keyed by numeric value.
export const CreditResourceTypeLabels = {
  0: "None",
  1: "Trial",
  2: "Promotion",
  3: "BulkSale",
  4: "AppleStore",
  5: "GoogleStore",
  6: "OnlineSale",
  7: "HuaweiStore",
  8: "HuaweiIyzico",
  9: "External",
};

// Iyzico refund is only supported for these CreditResourceType values.
export const REFUNDABLE_CREDIT_TYPES = [
  CreditResourceType.OnlineSale, // 6
  CreditResourceType.HuaweiIyzico, // 8
  CreditResourceType.External, // 9
];

export const getCreditTypeLabel = (type) => {
  const key = Number(type);
  return CreditResourceTypeLabels[key] !== undefined
    ? CreditResourceTypeLabels[key]
    : String(type);
};

export const isRefundableType = (type) =>
  REFUNDABLE_CREDIT_TYPES.includes(Number(type));

export default CreditResourceType;
